// projects/humanresources-general/src/assets/i18n/*/hr-gen-hrm-type.json
export class HrGenHrmTypeKey {
    private static readonly keyPrefix = 'hrGenHrmType';
    public static pageHeader = `${HrGenHrmTypeKey.keyPrefix}.pageHeader`;
    public static locale = `${HrGenHrmTypeKey.keyPrefix}.locale`;
}
